<template>
  <div class="search">
    <input type="text" placeholder="Search " />
    <div>
      <img src="./../../assets/images/search.svg" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "Search"
};
</script>

<style lang="scss" scoped>
.search {
  max-width: 293px;
  height: 35px;
  overflow: hidden;
  border: solid 1px #caced5;
  background-color: #ffffff;
  position: relative;

  > input {
    height: 35px;
    font-size: 0.833vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    border: none;
    outline: none;
    padding-left: 50px;
    padding-right: 5px;

    @media (max-width: 1400px) {
      padding-left: 35px;
    }
  }

  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 50px;
    text-align: center;
    padding-top: 5px;

    > img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
